import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import './style.css';
import ReactComponent from "../ReactComponent";
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import {
	Table,
	Button,
	Spin,
	Icon,
	Form,
	Input,
	DatePicker,
	TreeSelect
} from 'antd';
import attendanceRecordService from '../../services/Attendance/attendance-record-service';
import { fetchDepartmentsList } from '../../actions/department-structure-actions.js';
const webConfig = require ('../../config.json');

class AttendanceDailyRecordDetail extends ReactComponent {

  constructor(props){
    super(props);
    this.goBack = this.goBack.bind(this);
  }

	dataMode = 1
	state = {
		filters: {
			current_record_date: this.props.routing.location.pathname.split('/')[3],
			department_id: "",
			real_name: "",
			job_number: "",
			page: 1
		},
		department_value: "",
		data: [],
		dataStatus: "unload"
	}

	actions = {
		selectAction: attendanceRecordService.selectAttendanceDailyRecordDetail,
		exportAction: attendanceRecordService.exportAttendanceDailyRecordDetail,
	}

	customComponentWillMount() {
		this.props.fetchDepartmentsList();
	}

	setDateFilter = (moment, date) => this.setState({
		dataStatus: "loading",
		filters: {
			...this.state.filters,
			current_record_date: date,
			page: 1
		}
	}, this.reloadAction)

	setPageFilter = pagination => this.setState({
		dataStatus: "loading",
		filters: {
			...this.state.filters,
			page: pagination.current
		}
	}, this.reloadAction)

	setEmployeeFilter = value => this.setState({
		dataStatus: "loading",
		filters: {
			...this.state.filters,
			real_name: value,
			job_number: value
		}
	}, this.reloadAction)

	setDepartmentFilter = value => this.setState({
		dataStatus: "loading",
		filters: {
			...this.state.filters,
			department_id: value + ""
		}
	}, this.reloadAction)

	setChangeEmployeeFilter = event => {
		if (!event.target.value) {
			this.setEmployeeFilter();
		}
	}

	exportAttendance = () => {
		let gets = {};
		Object.keys(this.state.filters).forEach(key => {
			if (this.state.filters[key]) {
				gets[key] = this.state.filters[key];
			}
		});
		delete gets.page;
		this.publicExport(gets);
	}

	renderTreeNodes = data => data.map(item => {
		if (item.children) {
			return (
				<TreeSelect.TreeNode title={item.name}
					value={item.id + ""}
					key={item.id}
					dataRef={item}>
						{this.renderTreeNodes(item.children)}
				</TreeSelect.TreeNode>
			);
		}
		return <TreeSelect.TreeNode {...item} />
	})

goBack(){
  this.props.history.goBack();
}

	render () {
		const column = [{
				title: '部门',
				dataIndex: 'department_name',
				key: 'department_name',
				className: "table-global-head"
			}, {
				title: '姓名',
				dataIndex: 'employee_name',
				key: 'employee_name',
				className: "table-global-head"
			}, {
				title: '签到',
				dataIndex: 'on_time',
				key: 'on_time',
				className: "table-global-head"
			},{
				title: '签退',
				dataIndex: 'off_time',
				key: 'off_time',
				className: "table-global-head"
			}, {
				title: '实际出勤小时数',
				dataIndex: 'actual_attendance_hours',
				key: 'actual_attendance_hours',
				className: "table-global-head"
			}, {
				title: '假期及其他',
				dataIndex: 'type',
				key: 'type',
				className: "table-global-head"
			},{
				title: '申诉理由',
				dataIndex: 'content',
				key: 'content',
				className: "table-global-head"
			}
		];
		return (
			<div className="app-module-item">
				<div style={{marginBottom: "20px"}}>
					<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>

							<Button type="primary" onClick={this.goBack}>
								<Icon type="arrow-left" />
								<span>返回</span>
							</Button>

					</div>
					<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.exportAttendance}>
							<Icon type="cloud-upload-o" />
							<span>导出</span>
						</Button>
					</div>
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<Input.Search
							placeholder="报告人 工号/姓名"
							onSearch={this.setEmployeeFilter}
							onChange={this.setChangeEmployeeFilter}
							style={{ width: 200 }}
							defaultValue={this.state.filters.real_name}
							enterButton />
					</div>
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<Form layout="inline" style={{float:'left'}}>
							<Form.Item>
							{this.props.form.getFieldDecorator('department_id', {
								rules: [],
								initialValue: this.state.filters.department_id
							})(<TreeSelect style={{minWidth:"300px"}}
									placeholder="请选择部门"
									showSearch={false}
									autoExpandParent={true}
									dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
									treeDefaultExpandAll
									onChange={this.setDepartmentFilter}>
										{ this.props.departmentStructure.departmentsList &&
										this.renderTreeNodes(this.props.departmentStructure.departmentsList) }
								</TreeSelect>
							)}
							</Form.Item>
						</Form>
					</div>	
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<span style={{marginRight:"5px"}}>选择日期 : </span>
						<DatePicker onChange={this.setDateFilter}
							placeholder="请选择日期"
							value={this.state.filters.current_record_date ? 
								moment(this.state.filters.current_record_date) : null} />
					</div>
					<div style={{clear:"both"}}></div>
				</div>
				<div>
					{(() => {
						switch (this.state.dataStatus) {
							case "loaded":
								return (
									<Table columns={column}
									dataSource={this.state.data.Data}
									scroll={{x: 800}}
									rowKey={(record, index) => index}
									pagination={{
											total: this.state.data.Total,
											pageSize: this.state.data.PageSize,
											current: this.state.filters.page}}
									onChange={this.setPageFilter} />)
							case "error":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "reload":
							case "unload":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										<Spin size="large" />
									</div>);
							default :
								return null;
						}
					})()}
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		routing: state.routing,
		departmentStructure: state.departmentStructure
	}
}

const mapDispatchToProps = {
	fetchDepartmentsList
}

AttendanceDailyRecordDetail = Form.create()(AttendanceDailyRecordDetail)

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(AttendanceDailyRecordDetail));









// WEBPACK FOOTER //
// ./src/routes/Attendance/AttendanceDailyRecordDetail.js